<template>
  <div class="header">
    <div class="image-frame">
      <img src="https://cdn.statically.io/gh/red-rooster-bistro/red-rooster-bistro.github.io/master/assets/front.jpg" alt="Banner image" aria-label="Banner image" />
    </div>
    <b-navbar toggleable="lg">
      <b-navbar-nav class="mx-auto">
        <b-nav-item :active="$route.name === 'Home'" to='/'>Home</b-nav-item>
        <b-nav-item :active="$route.name === 'Menu'" to='/menu'>Menu</b-nav-item>
        <b-nav-item :active="$route.name === 'Gallery'" to='/gallery'>Gallery</b-nav-item>
        <b-nav-item :active="$route.name === 'About'" to='/about'>About</b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
  .navbar {
    margin-top: -60px;
    padding: 0;
  }

  /* .image-frame {
    padding-top: 20px;
    padding-bottom: 20px;
  } */

  img {
    width: 100%;
    min-height: 400px;
    max-height: 500px;
    /* display: block; */
    /* margin: 0 auto; */
    object-fit: cover;
  }

  .nav-item {
    padding-left: 10px;
    padding-right: 10px;
    display: inline-block;
    min-width: 60px;
    height: 100%;
  }

  .navbar-nav {
    display: inline-block;
    text-align: center;
  }

  .nav-link {
    font-size: 1.6em;
    line-height: 30px;
    color: #f7f7f7 !important;
  }

  .nav-link:hover {
    color: #8a0707 !important;
    border-bottom: 2px solid #8a0707;
  }

  .active {
    border-bottom: 2px solid #8a0707;
  }

  .image-frame::after {
    display: block;
    position: relative;
    background-image: linear-gradient(to bottom, transparent 0%, black 100%);
    margin-top: -150px;
    height: 150px;
    width: 100%;
    content: '';
  }

  @media only screen and (max-width: 600px) {
    .nav-link {
      font-size: 1.2em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue